var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherDust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.9 7.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.6,
    y1: 0.5,
    x2: 6.6,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.8,
    y1: 0.5,
    x2: 10.4,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 0.5,
    x2: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.6,
    y1: 7,
    x2: 6.6,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.8,
    y1: 7,
    x2: 10.4,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 7,
    x2: 0.5,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.6,
    y1: 4.9,
    x2: 6.6,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.3,
    y1: 2.8,
    x2: 4.4,
    y2: 2.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 4.9,
    x2: 4.4,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.1,
    y1: 2.8,
    x2: 0.5,
    y2: 2.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.4,
    y1: 2.8,
    x2: 10.4,
    y2: 2.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.8,
    y1: 4.9,
    x2: 10.4,
    y2: 4.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherDust);
export default __webpack_public_path__ + "static/media/icon_weather_dust.f18e6c3b06d0a4b636d2bba423e6a62a.svg";
export { ForwardRef as ReactComponent };